import wootConstants from 'dashboard/constants/globals';

export const mergeRealtimeMessages = (existing = [], incoming = []) => {
  const messages = [...existing];
  incoming.forEach(message => {
    const index = messages.findIndex(
      item =>
        item.id === message.id ||
        (message.echo_id && item.id === message.echo_id) ||
        (item.echo_id && item.echo_id === message.id) ||
        (message.echo_id && item.echo_id === message.echo_id)
    );
    if (index === -1) {
      messages.push(message);
    } else {
      const current = messages[index];
      // Existing server messages may already include a later update/reaction.
      const incomingIsNewer =
        current.id === message.echo_id ||
        (message.updated_at &&
          current.updated_at &&
          new Date(message.updated_at) > new Date(current.updated_at));
      const merged = incomingIsNewer
        ? { ...current, ...message }
        : { ...message, ...current };
      const currentReaction = current.content_attributes?.whatsapp_reaction;
      const incomingReaction = message.content_attributes?.whatsapp_reaction;
      const reaction =
        (currentReaction?.revision || 0) >= (incomingReaction?.revision || 0)
          ? currentReaction
          : incomingReaction;
      if (reaction) {
        merged.content_attributes = {
          ...merged.content_attributes,
          whatsapp_reaction: reaction,
        };
      }
      messages[index] = merged;
    }
  });
  return messages.sort((a, b) => a.created_at - b.created_at || a.id - b.id);
};

export const mergeRealtimeConversation = (existing, snapshot) => {
  const existingIsNewer =
    (existing.updated_at || 0) >= (snapshot.updated_at || 0);
  return {
    ...(existingIsNewer ? snapshot : existing),
    ...(existingIsNewer ? existing : snapshot),
    messages: mergeRealtimeMessages(existing.messages, snapshot.messages),
    last_activity_at: Math.max(
      existing.last_activity_at || 0,
      snapshot.last_activity_at || 0
    ),
    timestamp: Math.max(existing.timestamp || 0, snapshot.timestamp || 0),
    dataFetched: existing.dataFetched,
    allMessagesLoaded: existing.allMessagesLoaded,
  };
};

// allConversations stores entities; the list getters still apply their filters.
// Mentions/participating membership must be confirmed by their server list/event.
export const getListConversations = state => {
  const { MENTION, PARTICIPATING } = wootConstants.CONVERSATION_TYPE;
  if (
    ![MENTION, PARTICIPATING].includes(
      state.conversationFilters?.conversationType
    )
  ) {
    return state.allConversations;
  }
  return state.allConversations.filter(
    conversation => !state.realtimeConversationIds?.[conversation.id]
  );
};
